import { Component, OnInit } from '@angular/core';
import { LoginContext } from 'src/services/login-context.model';
import { ApiService } from 'src/services/api.service';
import { CredentialsService } from 'src/app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { UserRegistrationDocumentService } from 'src/app/user-registration/user-registration-document/user-registration-document.service';
import { FormValue } from 'src/services/FormValue';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  profile: LoginContext | null;
  currentUser: any;
  userForm: FormGroup;
  errorMsg: string = "default";
  submitted: boolean = false;
  loading: boolean = false;

  stateList: {}
  countryList: {}
  lgaList: {};
  uploadFiles: any[] = [];
  nationalityList: {};

  formOfIdLabel = "Identity Number";

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private apiService: ApiService,
              private credentialsService: CredentialsService,
              private toastService: ToastService,
              public documentService: UserRegistrationDocumentService) {
    this.profile = this.credentialsService.credentials;
    this.currentUser = this.profile.user;
    this.userForm = this.initializeForm();
    this.getCountries();
    this.getNationality();
  }

  ngOnInit() {
    this.setFormData();
  }

  initializeForm() {
    return this.userForm = this.formBuilder.group({
      'firstname': ['', Validators.required],
      'surname': ['', Validators.required],
      'otherName': [''],
      'phoneNumber': [''],
      'nationalityFk': this.formBuilder.group({
        'id': ['', Validators.required]
      }),
      'countryFk': this.formBuilder.group({
        'id': ['', Validators.required]
      }),
      'occupation': ['', Validators.required],
      'state': ['', Validators.required],
      'city': ['', Validators.required],
      'lga': ['', Validators.required],
      'address': ['', Validators.required],
      'postcode': ['', Validators.required],
      'streetNumber': ['', Validators.required],
      'identityType': ['', [Validators.required]],
      'nin': ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]]
    });
  }

  controlTypeOfIdValidators(value:string){
    this.formOfIdLabel = value+" Number";
    if (value=="Driver's License"){
      this.userFormControl.nin.setValidators([Validators.required, Validators.minLength(10)]);
      this.userFormControl.nin.updateValueAndValidity();
    }
    else if (value=="International Passport"){
      this.userFormControl.nin.setValidators([Validators.required, Validators.minLength(8)]);
      this.userFormControl.nin.updateValueAndValidity();
    }
    else if (value=="National ID Card"){
      this.userFormControl.nin.setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
      this.userFormControl.nin.updateValueAndValidity();
    }
    else{
      this.userFormControl.nin.setValidators([Validators.required]);
      this.userFormControl.nin.updateValueAndValidity();
    }
  }

  setFormData() {
    this.userFormControl.firstname.setValue(this.currentUser.firstname);
    this.userFormControl.surname.setValue(this.currentUser.surname);
    this.userFormControl.otherName.setValue(this.currentUser.otherName);
    this.userFormControl.phoneNumber.setValue(this.currentUser.phoneNumber);
    this.userFormControl.nin.setValue(this.currentUser.nin);
    this.userFormControl.identityType.setValue(this.currentUser.identityType || "");
    this.userFormControl.city.setValue(this.currentUser.city);
    this.userFormControl.address.setValue(this.currentUser.address);
    this.userFormControl.lga.setValue(this.currentUser.lga || "");
    this.userFormControl.postcode.setValue(this.currentUser.postcode || "");
    this.userFormControl.streetNumber.setValue(this.currentUser.streetNumber || "");
    this.userFormControl.occupation.setValue(this.currentUser.occupation || "");
    this.userFormControl.nationalityFk.patchValue(this.currentUser.nationalityFk || { 'id': 0 });
    this.userFormControl.countryFk.patchValue(this.currentUser.countryFk || { 'id': 0 });

    if (this.currentUser.addressFk != null) {
      let country = this.currentUser.addressFk.country_fk;
      this.userFormControl.countryFk.patchValue(country);
      this.getStates(country.id);
      this.userFormControl.state.patchValue({ 'id': country.state_fk?.id || 0 });
      if (this.currentUser.nationalityFk == null && this.userFormControl.nationalityFk == null) {
        this.userFormControl.nationalityFk.patchValue(country);
      }
      if (this.currentUser.addressFk.state_fk) {
        this.userFormControl.state.patchValue(this.currentUser.addressFk.state_fk);
      }
    }

    if (this.userFormControl.countryFk.value.id > 0){
      this.getStates(this.userFormControl.countryFk.value.id);
    }
  }

  get userFormControl() {
    return this.userForm.controls;
  }

  getStates(country?: any) {
    let countryNameOrId = country ? country : "Nigeria";
    this.apiService.get_("/utility/find/states-in-country/" + countryNameOrId).subscribe((response) => {
      this.stateList = response.data;
      if (this.currentUser.state != null && this.currentUser.state.length > 0) {
        let stateId = this.getIdByName(this.stateList, this.currentUser.state);
        this.userFormControl.state.setValue(stateId);
        this.getLgas(stateId);
      }
    });
  }

  getNationality() {
    this.apiService.get_("/utility/find/nationality").subscribe(
      response => {
        this.nationalityList = response.data;
      },
      error => {
        console.log(error)
      }
    );
  };

  getCountries() {
    this.apiService.get_("/utility/find/country").subscribe(
      response => {
        this.countryList = response.data;
      },
      error => {
        console.log(error)
      }
    );
  };

  getLgas(stateName) {
    this.apiService.get_("/utility/find/lgas/" + stateName).subscribe(
      response => {
        this.lgaList = response.data;
        if (this.currentUser.lga != null && this.currentUser.lga.length > 0) {
          let lgaId = this.getIdByName(this.lgaList, this.currentUser.lga);
          this.userFormControl.lga.setValue(lgaId);
        }
      }
    );
  }

  getIdByName(objectData: any, value: string) {
    if (value && objectData) {
      for (const [fieldId, name] of Object.entries(objectData)) {
        let str = <string>name;
        if (str.toUpperCase() == value.toUpperCase()) {
          return <number><unknown>fieldId;
        }
      }
    }
    return value;
  }

  goBack() {
    window.history.back();
  }

  save() {
    let request = FormValue.get(this.userForm, true);
    this.currentUser = {...this.currentUser, ...request};
    this.currentUser.contactAddress = this.userFormControl.address.value;
    let stateId = this.currentUser.state;
    this.currentUser.state = this.stateList[stateId];
    this.currentUser.nationality = this.nationalityList[this.currentUser.nationalityFk.id];
    this.currentUser.nationalityFk.name = this.currentUser.nationality;
    this.currentUser.countryFk.name = this.countryList[this.currentUser.countryFk.id];

    if (!!this.currentUser.addressFk?.country_fk) {
      this.currentUser.addressFk.country_fk = {
        id: this.userFormControl.countryFk.value.id,
        name: this.countryList[this.userFormControl.countryFk.value.id],
        code: this.countryList[this.userFormControl.countryFk.value.id]
      };
    }

    if (stateId && !!this.currentUser.addressFk?.state_fk) {
      this.currentUser.addressFk.state_fk = {
        id: stateId,
        name: this.currentUser.state,
        code: this.currentUser.state
      };
      this.currentUser.addressFk.state_fk.country_fk = this.currentUser.countryFk;
      this.currentUser.addressFk.town_or_city = this.userFormControl.city.value;
      this.currentUser.addressFk.street_address = this.userFormControl.address.value;
    }

    this.submitted = true;
    if (this.userForm.valid) {
      this.loading = true;
      const returnUrl = "/dashboard";
      this.apiService.post_("/auth/edit/profile", this.currentUser).pipe(
        finalize(() => {
          this.loading = false;
        })
      ).subscribe((response: any) => {
        if (response.success && response.status == "OK") {
          this.profile.user = response.data;
          this.credentialsService.updateCredentials(this.profile);
          sessionStorage.setItem('accessToken', this.profile.token);
          sessionStorage.setItem('currentUser', JSON.stringify(this.profile.user));
          this.router.navigate([returnUrl]);
          this.toastService.showSuccess("User Profile Updated Succesfully!");
        }
        else {
          this.toastService.showDanger("Your User Profile Request Could Not Be Processed: " + response.message);
        }
      }, (error) => {
        console.log(error);
        this.toastService.showDanger("Request Could Not Be Processed at this time! Please Try Again later!");
      })
    }

  }

}
